import { IDonorProfileAddress } from '@nkr/models/donor-profile';

export const updateDonorAddress = {
    onNumericChange: (name: string, value: number, data: IDonorProfileAddress) => {
        switch (name) {
            case 'country': data.country = value; break;
        }

        return data;
    },

    onTextChange: (name: string, value: string, data: IDonorProfileAddress) => {
        switch (name) {
            case 'fullName': data.fullName = value; break;
            case 'addressLine1': data.addressLine1 = value; break;
            case 'addressLine2': data.addressLine2 = value; break;
            case 'city': data.city = value; break;
            case 'state': data.state = value; break;
            case 'postalCode': data.postalCode = value; break;
            case 'birthDate': data.birthDate = value; break;
            case 'phone': data.phone = value; break;
            case 'phone2': data.phone2 = value; break;
            case 'email': data.email = value; break;
        }

        return data;
    }
}